import React from 'react'

// STYLES
import withLogoStyles from './logo.style'

// COMPONENTS
import { LogoHelp, DescHelp } from '../app-icon/Icons'

const LogoHelpData = ({ classes }) => {
  return (
    <div className={classes.root}>
      <a href="/" className={classes.logoInner}>
        <LogoHelp />
        <DescHelp />
      </a>
    </div>
  )
}

export default withLogoStyles(LogoHelpData)
